import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/about/About'

const About: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'会社概要 代表挨拶 業務内容 役員'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/about/'}
        title="私たちについて | Aitria（アイトリア）"
        description="Aitria（アイトリア）の会社情報ページです。代表メッセージ、企業情報、会社沿革、役員紹介などをご覧いただけます。"
      />
      <Template />
    </>
  )
}

export default About
